import theme from "@/styles/theme";
import styled from "styled-components";
import { motion } from "framer-motion";

export const Card = styled(motion.div)<{ isActive: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: ${({ isActive }) =>
    isActive
      ? theme.colors.palete.brownLight
      : "#403b38"}; // Marrom escuro para desativado
  width: 93%;
  align-self: center;
  padding: 30px;
  border-radius: 5px;
  opacity: ${({ isActive }) =>
    isActive ? 1 : 0.6}; // Menos visível quando desativado
  filter: ${({ isActive }) =>
    isActive
      ? "none"
      : "grayscale(20%)"}; // Reduz levemente as cores quando desativado
  transition: all 0.3s ease-in-out;

  .top-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .left-container {
      display: flex;
      flex-direction: row;
      column-gap: 1vw;

      .label {
        color: ${({ isActive }) =>
          isActive ? "white" : "#B0A8A2"}; // Texto acinzentado se desativado
        font-family: sans-serif;
        font-weight: 600;
        font-size: ${theme.fontSize.md2};
      }
    }

    .right-container {
      display: flex;
      flex-direction: row;
      column-gap: 1vw;
      white-space: nowrap;

      .right-label {
        color: ${({ isActive }) =>
          isActive
            ? "white"
            : "#B0A8A2"}; // Cor do texto ajustada para desativado
        font-family: sans-serif;
        font-weight: 600;
      }
    }
  }

  .card-content {
    display: flex;
    align-self: center;
    margin-top: 2vh;
    margin-bottom: 2vh;
    width: 100%;
  }

  .bottom-container {
    display: flex;
    flex-direction: row;
    width: 100%;
    margin-top: 1vh;
    column-gap: 0.5vw;
    place-content: flex-end;

    .right-container {
      width: 50px;
      display: flex;
    }
  }
`;

export const CriterioContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  row-gap: 4vh;
  margin-bottom: 4vh;
  & :last-child {
  }
`;
export const NoScenario = styled.div`
  width: 93%;
  padding: 15px;
  border-radius: 5px;
  background: linear-gradient(to top right, #a9884d 80%, #c8a05e 50%);
  box-sizing: border-box;
  opacity: 1;
  align-self: center;
  place-items: center;
  margin-top: 2vh;
  text-align-last: center;
  .label-scenario {
    color: white;
    font-family: sans-serif;
    font-weight: 600;
    text-align-last: center;
    font-size: ${theme.fontSize.md};
  }
  .description-scenario {
    color: white;
    font-family: ${theme.fonts.primary};
    font-weight: 600;
    text-align-last: center;
    font-size: ${theme.fontSize.mm};
  }
  .button-continue {
    width: 250px;
    margin-top: 2vh;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;

  .no-active-criteria {
    width: 93%;
    padding: 15px;
    border-radius: 5px;
    background: linear-gradient(to top right, #a9884d 80%, #c8a05e 50%);
    box-sizing: border-box;
    opacity: 1;
    align-self: center;
    place-items: center;
    margin-bottom: 2vh;
    text-align-last: center;
    .label-criteria {
      color: black;
      font-size: ${theme.fontSize.mm};
    }
  }
`;
export const OracleContainer = styled.div<{ isActive: boolean }>`
  display: flex;
  flex-direction: column;
  width: 95%;
  align-self: center;
  height: 100%;
  background-color: ${({ isActive }) =>
    isActive ? theme.colors.palete.gold : "#332F2D"};
  .status {
    margin-top: 2vh;
    color: white;
    font-family: sans-serif;
    font-weight: 600;
    text-align-last: center;
    font-size: ${theme.fontSize.md};
  }
  .description {
    color: white;
    font-family: ${theme.fonts.primary};
    font-weight: 600;
    text-align-last: center;
    font-size: ${theme.fontSize.mm};
    margin-bottom: 2vh;
  }
  .button-continue {
    width: 250px;
    align-self: center;
    margin-bottom: 4vh;
  }
`;
